<template>
  <div class="uploadCertificate">
    <el-dialog
      title="重新上传凭证"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="140px"
        >
          <el-form-item label="转账人姓名" prop="remitterName">
            <el-input
              v-model="formInline.remitterName"
              style="width: 350px"
              placeholder="请输入转账人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="凭证图片" prop="remitterVoucher">
            <el-upload
              ref="upload"
              list-type="picture-card"
              :format="['jpg', 'jpeg', 'png']"
              accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG"
              :limit="9"
              :action="uploadHost"
              :data="uploadData"
              :file-list="formInline.remitterVoucher"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-exceed="handleExceed"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="clearAll">清空凭证</el-button>
        <el-button size="small" type="primary" @click="handleAffirm">保 存</el-button>
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
import {
  getAuditInfoByOrderId,
  submitRemitVoucher,
} from "@/api/orderAdmin/orderList";
import { getPrivateImgUrl } from '@/api/product/base'
export default {
  data() {
    return {
      dialogVisible: false,
      formInline: {
        remitterName: "",
        remitterVoucher: [],
      },
      rules: {
        remitterName: [
          { required: true, message: "请输入转账人姓名", trigger: "blur" },
        ],
        remitterVoucher: [{ required: true, message: "请上传凭证图片" }],
      },
      uploadHost: "",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      orderId: "",
      orderSource: "",
      // 私有域名集合
      remitterVoucherList: []
    };
  },
  watch: {
    "formInline.remitterVoucher": {
      handler(to) {
        if (to) {
          this.$nextTick(() => {
            this.$refs.formInline.clearValidate("remitterVoucher");
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    // 清除凭证
    clearAll() {
      this.formInline = {
        remitterName: "",
        remitterVoucher: [],
      };
    },
    // 初始化
    async init(payload) {
      this.orderId = payload.id;
      const res = await getAuditInfoByOrderId({ orderId: payload.id });
      this.orderSource = payload.orderSource || "";
      let remitterVoucherList = res.data?.remitterVoucher?.split(",") || [];
      this.remitterVoucherList = remitterVoucherList
      let arr = remitterVoucherList.map((item, index) => {
        return { name: `图片${index}`, url: item };
      });
      arr.forEach(item => {
        getPrivateImgUrl(item.url).then(res1 => {
          item.url = res1.data
        })
      })
      this.formInline = {
        remitterName: res.data?.remitterName || "",
        remitterVoucher: arr,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          let arr = this.remitterVoucherList.map((item) => {
            return item;
          });
          const params = {
            orderId: this.orderId,
            // orderSource: this.orderSource,
            remitterName: this.formInline.remitterName,
            remitterVoucher: arr.join(","),
          };
          if (this.orderSource === 3) {
            params.orderSource = this.orderSource
          }
          submitRemitVoucher({ ...params }).then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                message: "上传成功",
                type: "success",
              });
              this.dialogVisible = false;
            }
          });
        }
      });
    },
    // 上传前的回调函数
    beforeUpload(file) {
      return oss(file.name, 1, "").then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
      });
    },
    // 上传成功的回调函数
    handleSuccess(response, file, fileList) {
      // 获取公有链接
      getpublicImgUrl(this.fileData.fileName).then((res) => {
        if (res.code === 0) {
          file.url = res.data;
          this.formInline.remitterVoucher.push(file);
          this.remitterVoucherList.push(this.fileData.fileName)
        } else {
          this.$message.success("获取图片链接失败");
        }
      });
    },
    // 图片删除
    handleRemove(file, fileList) {
      let i
      let data = this.formInline.remitterVoucher.filter((value, index) => {
        if (value.url === file.url) {
          i = index
        }
        return value.url !== file.url;
      });
      this.formInline.remitterVoucher = data;
      this.remitterVoucherList.splice(i, 1)
    },
    // 超出个数
    handleExceed() {
      this.$message({
        message: "最多上传9张图片！",
        type: "warning",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadCertificate {
  ::v-deep {
    .el-upload-list__item {
      transition: none !important;
    }
    .el-upload-list__item.is-ready {
      display: none !important;
    }
  }
}
</style>
